import request from '@/utils/request'

// 管理员登录接口
// 注意：登录失败以 HTTP 200 + 响应体 code 返回（401=密码错误含剩余次数，429=已锁定）
export function login(param) {
  return request({
    url: '/v1/manager/login',
    method: 'post',
    data: param
  })
}

// 管理员登出接口（登出后服务端立即吊销 token）
export const logout = () => {
  return request({
    url: '/v1/manager/logout',
    method: 'post'
  })
}

// 修改当前登录管理员密码
// 注意：失败以 HTTP 200 + 响应体 code=400 返回（旧密码错误 / 新密码长度不合法）
export function updatePassword(data) {
  return request({
    url: '/v1/manager/updatePassword',
    method: 'put',
    data
  })
}
